import { render, staticRenderFns } from "./setConfirm.vue?vue&type=template&id=636b3f72&scoped=true"
import script from "./setConfirm.vue?vue&type=script&lang=js"
export * from "./setConfirm.vue?vue&type=script&lang=js"
import style0 from "./setConfirm.vue?vue&type=style&index=0&id=636b3f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b3f72",
  null
  
)

export default component.exports